// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".summary-info .summary-info__package-info{flex:0 0 150px;grid-area:package-info}@media(max-width:1023px){.summary-info .summary-info__package-info{flex-basis:110px}}@media(max-width:599px){.summary-info .summary-info__package-info{text-align:center}}.summary-info .summary-info__total-price{flex:0 0 100px;text-align:right;grid-area:total-price}", ""]);
// Exports
module.exports = exports;
